export enum LabelType {
  None = "なし",
  Yellow = "yellow",
  Pink = "pink",
  LightBlue = "light-blue",
  Green = "green",
}
